module.exports = __webpack_public_path__ + "img/Out of Round.0c16b2ad.png";